export const JARVIS_VERSION = '2.0.0';

export enum LocalStorageKeys {
  AuthToken = 'auth_token',
  AccessToken = 'access_token',
  RefreshToken = 'refresh_token',
  UserId = 'user_id',
  DeviceId = 'device_id',
  BrowserId = 'browser_id',
}
